import { Injectable } from '@angular/core';
import { register as registerDmsViewer } from '@onviobr/toolbox-viewer/publish';

@Injectable({
	providedIn: 'root'
})
export class DmsViewerService {
	constructor() { }
	public registerDms(): void {
		registerDmsViewer();
	}
}
